import * as React from "react";
import {PostApiService} from "../../core/api/post/PostApiService";
import {IReadNewsResponse} from "../../core/api/post/response/ReadNewsResponse";

interface IProps {
    navClass?: string;
}

interface IState{
    newsData: IReadNewsResponse[] | undefined;
}

export class NewsLastPost extends React.Component<IProps, IState> {

    private readonly postService = new PostApiService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            newsData: undefined
        }
    }

    public componentDidMount = () =>{
        this.fetchData();
    };

    public render() {
        return (
            <div className="widget">
                <h5 className="widget-title font-alt">Berita Terakhir</h5>
                <div className="widget-body">
                    {this.state.newsData === undefined ? <p>Loading...</p> : (
                        <ul className="clearlist widget-posts">
                            {this.state.newsData.length < 1 ? <p>Tidak ada berita.</p> : this.state.newsData.map((item, index) =>
                                <li className="clearfix" key={index}>
                                    <a href={'/berita/' + item.slug}>
                                        <img className="widget-posts-img" src={item.image} alt={item.title} />
                                    </a>
                                    <div className="widget-posts-descr">
                                        <a href={'/berita/' + item.id}>{item.title}</a>
                                        Diposting tanggal {item.dateTime}
                                    </div>
                                </li>
                            )}
                        </ul>
                    )}
                </div>
            </div>
        );
    }

    private fetchData = () => {
        this.postService.getNews(3)
            .then((response: any) => {
                this.setState({
                    newsData: response.result
                })
            }).catch((error) => {
            this.setState({
                newsData: []
            })
        })
    }

}


// WEBPACK FOOTER //
// ./src/component/news/NewsLastPost.tsx